todos-index
  todos-table(tag-scope="todos_table")
  script(type="typescript").
    this.mixin('base');
